import { render, staticRenderFns } from "./limits-editable-table.vue?vue&type=template&id=f9e95d34&scoped=true&"
import script from "./limits-editable-table.vue?vue&type=script&lang=js&"
export * from "./limits-editable-table.vue?vue&type=script&lang=js&"
import style0 from "./limits-editable-table.vue?vue&type=style&index=0&id=f9e95d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e95d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9e95d34')) {
      api.createRecord('f9e95d34', component.options)
    } else {
      api.reload('f9e95d34', component.options)
    }
    module.hot.accept("./limits-editable-table.vue?vue&type=template&id=f9e95d34&scoped=true&", function () {
      api.rerender('f9e95d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/limits-editable-table.vue"
export default component.exports